import dayjs from 'dayjs';

import { getDiffDate, parseFullDateFromDb } from './date';
import { TC_COLORS } from '../constants/colors';

export const getMarginFee = (loan, feeMargin, purchaseDate, endDate = null) => {
  if (!Number(loan) || !feeMargin?.length) {
    return 0;
  }
  let fee = 0;
  const defaultFee = feeMargin.find((f) => f.type === 'default');
  const parsePurchaseDate = parseFullDateFromDb(purchaseDate);
  const day = getDiffDate(parsePurchaseDate, endDate) || 1;
  if (defaultFee) {
    const feePerDay = ((Number(loan) * defaultFee.fee) / 100 / 365).toFixed(2);
    fee += Number(feePerDay) * day;
  }

  const customFee = feeMargin.filter((f) => f.type === 'custom');
  if (customFee.length) {
    if (customFee[0].day >= day) {
      const feePerDay = ((Number(loan) * customFee[0].fee) / 100 / 365).toFixed(
        2
      );
      fee = Number(feePerDay) * day;
    } else {
      const feePerDay = ((Number(loan) * customFee[0].fee) / 100 / 365).toFixed(
        2
      );
      fee = Number(feePerDay) * customFee[0].day;
      let startDay = customFee[0].day;
      let tmpDay = customFee[0].day;
      for (let i = 1; i < customFee.length - 1; i++) {
        const item = customFee[i];
        startDay += item.day;
        const feePerDay = (
          (Number(loan) * customFee[i].fee) /
          100 /
          365
        ).toFixed(2);
        if (startDay >= item.day) {
          fee += Number(feePerDay) * (startDay - tmpDay);
        } else {
          tmpDay += item.day;
          fee += Number(feePerDay) * item.day;
        }
      }
      if (startDay < day) {
        const feePerDay = (
          (Number(loan) * customFee[customFee.length - 1].fee) /
          100 /
          365
        ).toFixed(2);
        fee += Number(feePerDay) * (day - startDay);
      }
    }
  }
  return fee;
};

export const removeVietnameseTones = (str) => {
  if (!str) {
    return '';
  }
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '');
  str = str.replace(/\u02C6|\u0306|\u031B/g, '');
  str = str.replace(/-/g, '');
  str = str.replace(/,/g, '');
  str = str.replace(/ + /g, ' ');
  str = str.replaceAll('.', '');
  str = str.replace(/ /g, '-');
  return str;
};

export const toPlainString = (num) => {
  return `${+num}`.replace(/(-?)(\d*)\.?(\d*)e([+-]\d+)/, (a, b, c, d, e) => {
    return e < 0
      ? `${b}0.${Array(1 - e - c.length).join('0')}${c}${d}`
      : b + c + d + Array(e - d.length + 1).join('0');
  });
};

export const getMinMax = (arr) =>
  arr.reduce(([min, max], val) => [Math.min(min, val), Math.max(max, val)], [
    Number.POSITIVE_INFINITY,
    Number.NEGATIVE_INFINITY,
  ]);

export const generateMinMaxChartData = (
  min,
  max,
  step = 5,
  offset = 1,
  isCeil = false
) => {
  let result = {
    min: 0,
    max: 0,
  };
  let inputMin = min * offset;
  let inputMax = max * offset;
  let minVal = Math.floor(inputMin - Math.floor(inputMin) * 0.01);
  if (minVal % step !== 0) {
    const minRange = minVal / step;
    const tmpMin = minVal;
    for (let i = 1; i <= minRange; i += 1) {
      minVal = tmpMin - i;
      if (minVal % step === 0) {
        break;
      }
    }
  }
  const maxTmp = Math.ceil(inputMax);
  const range = parseInt((maxTmp - minVal).toString(), 10);
  let valRange = range;
  if (range % step !== 0) {
    const x = Math.ceil(range / step);
    for (let i = 1; i <= x; i += 1) {
      valRange = range + i;
      if (valRange % step === 0) {
        break;
      }
    }
  }
  const maxVal = minVal + valRange;
  result = {
    min: minVal / offset,
    max: isCeil ? Math.ceil(maxVal / offset) : maxVal / offset,
  };

  return result;
};

export const getQueryParam = (name, url = '') => {
  const url_string = url || window.location.href;
  var url = new URL(url_string);
  return url.searchParams.get(name);
};

export const getStatusColor = (gia, giathamchieu, giatran, giasan) => {
  if (!gia || !giathamchieu || !giatran || !giasan) {
    return TC_COLORS.DEFAULT;
  }
  const newGiatran = Number(giatran.toFixed(2));
  const newGiasan = Number(giasan.toFixed(2));

  if (gia <= newGiasan) {
    return TC_COLORS.BLUE;
  }

  if (gia >= newGiatran) {
    return TC_COLORS.PURPLE;
  }

  if (gia === giathamchieu) {
    return TC_COLORS.YELLOW;
  }

  if (gia > giathamchieu) {
    return TC_COLORS.GREEN;
  }

  if (gia < giathamchieu) {
    return TC_COLORS.RED;
  }

  return TC_COLORS.DEFAULT;
};

export const getColumnColor = (value) => {
  if (Number(value) > 0) {
    return TC_COLORS.GREEN;
  }

  if (Number(value) < 0) {
    return TC_COLORS.RED;
  }

  return TC_COLORS.YELLOW;
};

const getFractionDigits = (min, max, range = 6) => {
  const convertValue = (x) => {
    if (max > 1000000000) {
      return x / 1000000000;
    } else if (max > 1000000) {
      return x / 1000000;
    } else if (max > 1000) {
      return x / 1000;
    }
    return x;
  };
  const calcFractionDigits = (x) => {
    let result = 0;
    const str = x.toString().replace('.', '');
    for (let i = 0; i < str.length; i++) {
      if (str[i] !== '0') {
        break;
      }
      result = i + 1;
    }
    return result;
  };
  const val = (max - min) / range;
  let fractionDigits = 0;
  if (val < 1) {
    fractionDigits = calcFractionDigits(val);
  } else {
    fractionDigits = calcFractionDigits(convertValue(val));
  }

  return fractionDigits;
};

export const getAxisLabel = (
  value,
  min,
  max,
  range = 6,
  fractionDigit = null,
  isVietnam = false
) => {
  if (value === 0) {
    return 0;
  }
  const fractionDigits =
    fractionDigit !== null ? fractionDigit : getFractionDigits(min, max, range);
  if (value.toFixed(fractionDigits) === '-0') {
    return '0';
  }
  const format = (x, delimiter = ',') => {
    let newValue1 = x;
    let suffix = '';
    if (max > 1000000000) {
      newValue1 = Number(x) / 1000000000;
      suffix = isVietnam ? 'Tỷ ' : 'B';
    } else if (max > 1000000) {
      newValue1 = Number(x) / 1000000;
      suffix = isVietnam ? 'Tr ' : 'M';
    } else if (max > 1000) {
      newValue1 = Number(x) / 1000;
      suffix = isVietnam ? 'K ' : 'K';
    }
    return `${new Intl.NumberFormat('ja-JP').format(
      Number(newValue1.toFixed(fractionDigits))
    )}${suffix}`;
  };
  return format(value);
};

const getFirstLetter = (text) => {
  if (!text) return '';
  return text
    .match(/(^\S)?/g)
    .join('')
    .toUpperCase();
};

export const getUserName = (userData) => {
  return (
    userData?.lastName ||
    userData?.firstName ||
    userData?.fullName ||
    userData?.userId
  );
};

export const getUserInfo = (userData) => {
  if (!userData) {
    return null;
  }
  return {
    fullName: `${userData.firstName} ${userData.lastName}`,
    firstName: userData.firstName,
    lastName: userData.lastName,
    userId: userData.userId,
    textAvatar: getFirstLetter(userData.lastName || userData.username),
    notificationOptions: userData.notificationOptions || '',
    userOptions: userData.userOptions || null,

    price: userData.packageUsage?.price || '',
    expiredDate: userData.packageUsage?.expiredDate || '',
    futuresExpiredDate: userData.futuresPackageUsage?.expiredDate || '',
    hasFeaturePackage: userData.hasFeaturePackage || false,
    futuresPackageStatus: userData.futuresPackageUsage?.status,
    createdAt: userData.createdAt || '',
    packageName: userData.packageUsage?.packageName || '',
    packageExpiredDate: userData.packageUsage?.expiredDate
      ? dayjs(userData.packageUsage?.expiredDate).format('DD/MM/YYYY')
      : '',
  };
};

export const getXAxisInterval = (xAxisData, width) => {
  if (width >= 1030) {
    return Math.floor(xAxisData.length / 3);
  }

  if ((width < 1030 && width >= 768) || (width < 530 && width >= 390)) {
    return Math.floor(xAxisData.length / 2);
  }

  if (width < 390) {
    return xAxisData.length;
  }

  return Math.floor(xAxisData.length / 3);
};

export const getXAxisInterval2 = (xAxisData, width) => {
  if (width >= 1030) {
    return Math.floor(xAxisData.length / 2);
  }

  if ((width < 1030 && width >= 768) || (width < 530 && width >= 390)) {
    return Math.floor(xAxisData.length / 2);
  }

  if (width < 390) {
    return xAxisData.length;
  }

  return Math.floor(xAxisData.length / 3);
};

export const mergedArray = (array1, array2, key) =>
  [...array1, ...array2].reduce((acc, item) => {
    const existingIndex = acc.findIndex((obj) => obj[key] === item[key]);
    if (existingIndex !== -1) {
      acc[existingIndex] = { ...acc[existingIndex], ...item };
    } else {
      acc.push(item);
    }
    return acc;
  }, []);

export const getAttributeData = (id, attr) => {
  const divElement = document.getElementById(id);
  return divElement?.getAttribute(attr);
};

export const isFeature = (stockID) => {
  if (!stockID || typeof stockID !== 'string') {
    return false;
  }
  return (
    stockID.toUpperCase().indexOf('VN30F') !== -1 ||
    stockID.toUpperCase().indexOf('41I1F') !== -1
  );
};


export const getLastWordName = (userData) => {
  const name = userData?.lastName ||
  userData?.firstName ||
  userData?.fullName ||
  userData?.userId || '';
  if (!name) {
    return '';
  }
  const parseName = name.split(' ')
  return parseName[parseName.length - 1];
};
